<!-- product-type-group-feature-display.component.html -->
<ng-container *ngIf="comparisonMode === 'version' && ptgFeatureComparisonData.length > 0">
    <ng-container *ngFor="let ptg of ptgFeatureComparisonData; let i = index; trackBy: trackById">
        <mat-expansion-panel *ngIf="ptg" class="groupFeatureCard" #panelVersion>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="flexContainer">
                        <div class="groupName">{{ ptg.ptgName }}</div>
                        <mat-icon class="info-tooltip-icon" color="primary"
                            *ngIf="ptg.ptgDescription != ''" matTooltip="{{ ptg.ptgDescription }}"
                        >
                            info_outline
                        </mat-icon>
                    </div>
                </mat-panel-title>
                
                <mat-panel-description style="justify-content: end;">
                    <div *ngIf="ptg.isCertified && !panelVersion.expanded"
                        matTooltip="Dieser Produkttyp wurde von einer unabhängigen Stelle zertifiziert."
                        [matTooltipPosition]="'above'" class="cert-image mg-rg"
                        [ngStyle]="{ 'background-image': 'url(/assets/svg-icons/certification.svg)' }">
                    </div>
                    <div class="centerGridItem mg-rg"
                        matTooltip="Gemäß Anbieter erfüllt dieses Produkt alle Funktionen die für den Anwendungsbereich (Produkttyp) verpflichtend notwendig sind."
                        *ngIf="doesProjectFulfillAllFeaturesOfPTGVersion(ptg.variants) &&  !panelVersion.expanded">
                        <mat-icon class="green-confirm">check</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="group-feature-list">
                <app-product-type-group-feature-list [title]="'Produkt Typen Group Merkmale'"
                    [tooltipText]="mandatoryFeaturesTooltip" [ptgFeatureComparisonData]="ptg">
                </app-product-type-group-feature-list>
            </div>
        </mat-expansion-panel>
    </ng-container>
</ng-container>

<!-- Where is this part used at? expansion-panel not implemented so far -->
<mat-card *ngIf="ptgVersionFeatures && (hasMandatoryFeatures() || hasOptionalFeatures())"
    class="groupFeatureCard mat-elevation-z4">
    <div class="gridContainer expandable" (click)="toggleMinimization()">
        <div class="flexContainer">
            <div class="groupName">{{ ptgVersionFeatures.ptgName }}</div>
            <mat-icon class="info-tooltip-icon" color="primary"
                *ngIf="ptgVersionFeatures.ptgDescription != ''" matTooltip="{{ ptgVersionFeatures.ptgDescription }}"
            >
                info_outline
            </mat-icon>
        </div>
        <div style="height: 24px; justify-self: center">
            <div class="centerGridItem"
                matTooltip="Gemäß Anbieter erfüllt dieses Produkt alle Funktionen die für den Anwendungsbereich (Produkttyp) verpflichtend notwendig sind."
                *ngIf="ptgVersionFeatures.doesProjectFulfillAllFeaturesOfPTGVersion">
                <mat-icon class="greenIcon">check</mat-icon>
                <!-- <mat-icon class="greenIcon sec-check-icon">check</mat-icon> -->
            </div>
            <!-- <img
            src="assets/img/misc/checkbox_ticked.png"
              width="24"
              height="24"
              class="centerGridItem"
              matTooltip="Gemäß Anbieter erfüllt dieses Produkt alle Funktionen die für den Anwendungsbereich (Produkttyp) verpflichtend notwendig sind."
              *ngIf="ptgVersionFeatures.doesProjectFulfillAllFeaturesOfPTGVersion"
          /> -->
        </div>
        <div class="expansionIcon">
            <!-- <mat-icon *ngIf="minimized; else notMinimized" color="primary">
              add
          </mat-icon> -->
            <img *ngIf="minimized; else notMinimized" src="assets/img/icons/arrow_down_green.png" alt="" width="20"
                height="20">
            <ng-template #notMinimized>
                <!-- <mat-icon color="primary"> remove </mat-icon> -->
                <img src="assets/img/icons/arrow_down_green.png" alt="" width="20" height="20" class="arrow-icon-up">
            </ng-template>
        </div>
    </div>
    <div [ngStyle]="{ display: minimized ? 'none' : 'block' }" class="group-feature-list">
        <app-product-type-group-feature-list *ngIf="hasMandatoryFeatures()" [title]="'Verpflichtende Merkmale'"
            [tooltipText]="mandatoryFeaturesTooltip"
            [features]="ptgVersionFeatures.mandatoryFeatures"></app-product-type-group-feature-list>
        <app-product-type-group-feature-list *ngIf="hasOptionalFeatures()" [title]="'Optionale Merkmale'"
            [tooltipText]="optionalFeaturesTooltip"
            [features]="ptgVersionFeatures.optionalFeatures"></app-product-type-group-feature-list>
    </div>
</mat-card>

<ng-container *ngIf="comparisonMode === 'variant' && ptgFeatureComparisonData2.length > 0">
    <ng-container *ngFor="let ptg of ptgFeatureComparisonData2; let i = index; trackBy: trackById">
        <mat-expansion-panel *ngIf="ptg " class="groupFeatureCard" #panelVariant>
            <mat-expansion-panel-header>
                <mat-panel-title>
                <div class="flexContainer">
                    <div class="groupName">{{ ptg.ptgName }}</div>
                    <mat-icon class="info-tooltip-icon" color="primary"
                        *ngIf="ptg.ptgDescription != ''" matTooltip="{{ ptg.ptgDescription }}"
                    >
                        info_outline
                    </mat-icon>
                </div>
                </mat-panel-title>
                <mat-panel-description style="justify-content: end;">
                    <div *ngIf="ptg.isCertified && !panelVariant.expanded"
                        matTooltip="Dieser Produkttyp wurde von einer unabhängigen Stelle zertifiziert."
                        [matTooltipPosition]="'above'" class="cert-image mg-rg"
                        [ngStyle]="{ 'background-image': 'url(/assets/svg-icons/certification.svg)' }">
                    </div>
                    <div class="centerGridItem mg-rg"
                        matTooltip="Gemäß Anbieter erfüllt dieses Produkt alle Funktionen die für den Anwendungsbereich (Produkttyp) verpflichtend notwendig sind."
                        *ngIf="doesProjectFulfillAllFeaturesOfPTGVersion(ptg.variants) && !panelVariant.expanded">
                        <mat-icon class="green-confirm">check</mat-icon>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="group-feature-list">
                <app-product-type-group-feature-list [title]="'Produkt Typen Group Merkmale'"
                    [tooltipText]="mandatoryFeaturesTooltip" [ptgFeatureComparisonData]="ptg"
                    [comparisonMode]="'variant'">
                </app-product-type-group-feature-list>
            </div>
        </mat-expansion-panel>
    </ng-container>
</ng-container>
